import { Injectable } from '@angular/core';
import { AuthGuardService } from '@shared/services/auth-guard.service';

@Injectable()
export class MainPagePermissionService {
  constructor(protected authGuardService: AuthGuardService) {}

  public get hasPermissionProductTag(): boolean {
    return this.authGuardService.checkPermission(['pm_product_tag_m']);
  }

  public get hasPermissionViewDestroy(): boolean {
    return this.authGuardService.checkPermission(['pm_dt_v']);
  }

  public get hasPermissionCashSettlement(): boolean {
    return this.authGuardService.checkPermission(['pm_cash_settle_m']);
  }
  public get hasPermissionStoreExpense(): boolean {
    return this.authGuardService.checkPermission(['pm_store_exp_req_m']);
  }
  public get hasPermissionStoreExpenseSendBack(): boolean {
    return this.authGuardService.checkPermission(['pm_store_exp_req_v', 'pm_store_exp_req_m']);
  }

  public get hasPermissionManagementTaskAssignment(): boolean {
    return this.authGuardService.checkPermission(['pm_task_m']);
  }
}
